import React, { useEffect, useState } from "react";
import { Table, Button, Spinner, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../../layouts/default";
import { DateTime } from "luxon";
import SmartPagination from "../EmailCampaignRunReport/DynamicSmartPagination";
import JsonModal from "../EmailCampaignRunReport/JsonModel";
import { getSmsCampaignDataIssues } from "../../../store/slices/smsCampaign";

const RECORDS_PER_PAGE = 10;

const SmsCampaignSummaryTable = () => {
    const { campaignId, campaignUuid, type } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [selectedPayload, setSelectedPayload] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const { smsDataIssueLogs } = useSelector((state) => state.smsCampaignReducer);
    const { dataIssues = [], totalCount = 0, dataIssueLoading } = smsDataIssueLogs;

    const totalPages = Math.ceil(totalCount / RECORDS_PER_PAGE);

    useEffect(() => {
        if (campaignUuid) {
            dispatch(
                getSmsCampaignDataIssues({
                    campaignUuid,
                    page: currentPage,
                    limit: RECORDS_PER_PAGE,
                    eventType: type || "",
                })
            );
        }
    }, [campaignUuid, currentPage, type, dispatch]);


    const openJsonModal = (payload) => {
        setSelectedPayload(payload);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    return (
        <Layout>
            <div className="pt-3">
                <Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
                    ← Back
                </Button>

                <Row className="align-items-center mb-4">
                    <Col>
                        <h4 className="mb-2 text-primary">Data Issues</h4>
                        <p className="mb-4 text-muted">
                            <strong>Campaign UUID:</strong> {campaignUuid} <br />
                            <strong>Campaign ID:</strong> {campaignId} <br />
                            {type && (
                                <>
                                    <strong>Filter Type:</strong> {type}
                                </>
                            )}
                        </p>
                    </Col>
                </Row>

                {dataIssueLoading ? (
                    <div className="text-center my-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <Table striped bordered hover responsive className="shadow-sm rounded">
                            <thead className="table-secondary">
                                <tr>
                                    <th>#</th>
                                    <th>Mobile</th>
                                    <th>Reason</th>
                                    <th>Date Time</th>
                                    <th>Raw JSON</th>
                                </tr>
                            </thead>

                            <tbody>
                                {Array.isArray(dataIssues) && dataIssues.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted">
                                            No Data Issues Found
                                        </td>
                                    </tr>
                                ) : (
                                    dataIssues.map((issue, index) => (
                                        <tr key={index}>
                                            <td>
                                                {(currentPage - 1) * RECORDS_PER_PAGE + index + 1}
                                            </td>

                                            <td>
                                                {issue.value ||
                                                    issue.mobile ||
                                                    issue?.rawPayload?.mobile ||
                                                    "Null"}
                                            </td>

                                            <td className="text-danger fw-bold">
                                                {issue.reason || issue?.rawPayload?.reason || "-"}
                                            </td>

                                            <td>
                                                {issue.dateTime
                                                    ? DateTime.fromISO(issue.dateTime)
                                                        .setZone("Asia/Kolkata")
                                                        .toFormat("dd MMM yyyy, hh:mm a")
                                                    : "-"}
                                            </td>

                                            <td>
                                                <Button
                                                    variant="outline-dark"
                                                    size="sm"
                                                    onClick={() => openJsonModal(issue.rawPayload || issue)}
                                                >
                                                    View JSON
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>

                        <div className="text-center mt-3 text-muted">
                            Showing {dataIssues.length} logs of {totalCount}. Page {currentPage} of{" "}
                            {totalPages}.
                        </div>

                        <SmartPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                        />

                        <JsonModal show={showModal} onClose={closeModal} payload={selectedPayload} />
                    </>
                )}
            </div>
        </Layout>
    );
};

export default SmsCampaignSummaryTable;
